import { render } from "./GlossaryDetail.vue?vue&type=template&id=120fdeb0&scoped=true&ts=true"
import script from "./GlossaryDetail.vue?vue&type=script&lang=ts"
export * from "./GlossaryDetail.vue?vue&type=script&lang=ts"

import "./GlossaryDetail.vue?vue&type=style&index=0&id=120fdeb0&lang=stylus"
import "./GlossaryDetail.vue?vue&type=style&index=1&id=120fdeb0&lang=stylus"
import "./GlossaryDetail.vue?vue&type=style&index=2&id=120fdeb0&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120fdeb0"]])

export default __exports__